import { BlockRow } from "../../../components/atoms/BlockRow/index";
import { Flex } from "../../../components/atoms/Flex/index";
import { HelpLink } from "../../../components/atoms/HelpLink/index";
import { InlineBlock } from "../../../components/atoms/InlineBlock/index";
import {
  MainSection,
  PageHeader,
} from "../../../components/atoms/MainSection/index";
import SwitchButton from "../../../components/atoms/SwitchButton";
import { Text } from "../../../components/general/Text";
import { useFlashMessage } from "../../../hooks/useFlashMessage";
import { Buildings } from "./Buildings/index";
import { useMutateStayLocationSettings } from "./useMutateStayLocationSettings";

const HELP_URL = "https://fs-help.studyplus.co.jp/ja/articles/5630467";

type Props = { sectionId: string; value: boolean | undefined };

export const StayLocationSettingsToggleForm = ({ sectionId, value }: Props) => {
  const { toggle } = useStayLocationSettingsToggleForm({ sectionId });

  return (
    <MainSection>
      <Flex justifyContent="space-between" marginTop="0">
        <div>
          <PageHeader>
            <Text as="span" size="xl">
              入退室記録の位置情報判定
            </Text>
            <InlineBlock marginLeft="2.4rem">
              <HelpLink to={HELP_URL}>
                <InlineBlock marginLeft="0.4rem">
                  <Text color="primary">位置情報判定とは？</Text>
                </InlineBlock>
              </HelpLink>
            </InlineBlock>
          </PageHeader>
          <BlockRow marginTop="1rem">
            <Text size="xs">
              ※オンにすると、設定した座標位置範囲に対して生徒の入退室記録の位置情報が範囲内か判定することができます。
            </Text>
          </BlockRow>
        </div>
        {value !== undefined ? (
          <SwitchButton
            value={value}
            label={{ on: "オン", off: "オフ" }}
            onChange={toggle}
            aria-label={`位置情報判定を${value ? "オフ" : "オン"}にする`}
          />
        ) : null}
      </Flex>
      <Buildings sectionId={sectionId} />
    </MainSection>
  );
};

const useStayLocationSettingsToggleForm = ({
  sectionId,
}: Pick<Props, "sectionId">) => {
  const mutation = useMutateStayLocationSettings({ sectionId });

  const { showSuccessMessage, showErrorMessage } = useFlashMessage();

  const handleSuccess = () => {
    showSuccessMessage("設定を更新しました");
  };

  const handleError = () => {
    showErrorMessage("設定が更新できませんでした");
  };

  const toggle = async (value: boolean) => {
    if (
      !window.confirm(
        `位置情報判定を「${
          value ? "オン" : "オフ"
        }」にしますか？\n登録済みの位置情報の取得及び判定がすべて${
          value ? "有効" : "無効"
        }になります。`,
      )
    ) {
      return !value;
    }

    const result = await mutation.mutateAsync(value);
    result.isSuccess ? handleSuccess() : handleError();

    return result.value;
  };

  return { toggle };
};
